import { render, staticRenderFns } from "./Process2.vue?vue&type=template&id=456b7a7e&scoped=true"
import script from "./Process2.vue?vue&type=script&lang=js"
export * from "./Process2.vue?vue&type=script&lang=js"
import style0 from "./Process2.vue?vue&type=style&index=0&id=456b7a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b7a7e",
  null
  
)

export default component.exports